import { Component, computed, input, OnInit, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { WorkflowStatus } from '#models';

export interface WorkflowInboxFilterState {
  searchText: string;
  asset: string | null;
  timeline: string;
  date: string | null;
  runForDate?: string | null;
  exceptionType: string | null;
  status: string | null;
  priority: string | null;
  workflowStatus?: WorkflowStatus | null;
  myPendingActions?: boolean;
}

@Component({
  selector: 'app-workflow-inbox-filter-modal',
  imports: [FormsModule],
  templateUrl: './workflow-inbox-filter-modal.component.html',
  styleUrl: './workflow-inbox-filter-modal.component.scss',
})
export class WorkflowInboxFilterModalComponent implements OnInit {
  initialSearchText = input<string>('');
  initialAsset = input<string | null>(null);
  initialTimeline = input<string>('all');
  initialDate = input<string | null>(null);
  initialRunForDate = input<string | null>(null);
  initialExceptionType = input<string | null>(null);
  initialPriority = input<string | null>(null);
  initialWorkflowStatus = input<WorkflowStatus | null>(null);
  initialMyPendingActions = input(false);
  assetOptions = input<string[]>([]);
  exceptionTypeOptions = input<string[]>([]);
  priorityOptions = input<string[]>([]);
  showCaseTypeFilter = computed(() => this.exceptionTypeOptions().length > 0);

  applied = output<WorkflowInboxFilterState>();
  cancelled = output<void>();

  draftSearchText = '';
  draftAsset: string | null = null;
  draftTimeline = 'all';
  draftDate = '';
  draftRunForDate = '';
  draftExceptionType: string | null = null;
  draftPriority: string | null = null;
  draftWorkflowStatus: WorkflowStatus | null = null;
  draftMyPendingActions = false;

  ngOnInit(): void {
    this.draftSearchText = this.initialSearchText();
    this.draftAsset = this.initialAsset();
    this.draftTimeline = this.initialTimeline();
    this.draftDate = this.initialDate() ?? '';
    this.draftRunForDate = this.initialRunForDate() ?? '';
    this.draftExceptionType = this.initialExceptionType();
    this.draftPriority = this.initialPriority();
    this.draftWorkflowStatus = this.initialWorkflowStatus();
    this.draftMyPendingActions = this.initialMyPendingActions();
  }

  onBackdropClick(): void {
    this.cancelled.emit();
  }

  onCloseClick(): void {
    this.cancelled.emit();
  }

  onCancelClick(): void {
    this.cancelled.emit();
  }

  onApplyClick(): void {
    this.applied.emit({
      searchText: this.draftSearchText.trim(),
      asset: this.draftAsset,
      timeline: this.draftTimeline,
      date: this.draftDate || null,
      runForDate: this.draftRunForDate || null,
      exceptionType: this.showCaseTypeFilter() ? this.draftExceptionType : null,
      status: null,
      priority: this.draftPriority,
      workflowStatus: this.draftWorkflowStatus,
      myPendingActions: this.draftMyPendingActions,
    });
  }
}
